import React from "react";
import { Label } from "./ui/label";

// Moduli per circuito: assente/true = attivo, false = disattivato. groups = [{group, items:[{key,label}]}]
export function ModulePicker({ groups = [], modules = {}, value = {}, onChange }) {
  const list = groups.length ? groups : [{ group: "Moduli", items: Object.entries(modules).map(([key, label]) => ({ key, label })) }];
  const isOn = (k) => value[k] !== false;
  const toggle = (k) => onChange({ ...value, [k]: isOn(k) ? false : true });
  const setGroup = (items, on) => onChange({ ...value, ...Object.fromEntries(items.map((i) => [i.key, on])) });
  const offCount = Object.values(value).filter((v) => v === false).length;
  return (
    <div className="space-y-3" data-testid="module-picker">
      <div className="flex items-center justify-between">
        <Label className="text-xs text-zinc-400">Moduli attivi {offCount > 0 ? <span className="text-amber-300">· {offCount} disattivati</span> : <span className="text-emerald-400">· tutti</span>}</Label>
        <button type="button" onClick={() => onChange({})} data-testid="module-picker-all" className="text-[11px] text-zinc-500 hover:text-zinc-200 underline">Attiva tutti</button>
      </div>
      {list.map((g) => (
        <div key={g.group} data-testid={`module-group-${g.group.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}>
          <div className="flex items-center gap-2 mb-1">
            <span className="text-[11px] uppercase tracking-wider text-zinc-500">{g.group}</span>
            <button type="button" onClick={() => setGroup(g.items, true)} className="text-[10px] text-zinc-500 hover:text-emerald-300">tutti</button>
            <button type="button" onClick={() => setGroup(g.items, false)} className="text-[10px] text-zinc-500 hover:text-amber-300">nessuno</button>
          </div>
          <div className="flex flex-wrap gap-2">
            {g.items.map((m) => (
              <button type="button" key={m.key} onClick={() => toggle(m.key)} data-testid={`tenant-module-${m.key}`} aria-pressed={isOn(m.key)}
                className={`px-3 py-1 rounded-full text-xs border transition-colors ${isOn(m.key) ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-300" : "border-zinc-800 text-zinc-500 line-through"}`}>{m.label}</button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
